module.exports = __webpack_public_path__ + "img/66.5f84052f.jpg";